import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CriarUsuarioFormData } from "../schema/criar-usuarios.schema";
import { EditarUsuarioFormData } from "../schema/editar-usuario.schema";
import { RecuperarSenhaFormData } from "../schema/recuperar-senha.schema";


const criar = async (data: CriarUsuarioFormData): Promise<void> => {
    try {
        await baseApiService.post('/user', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/user/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/user/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarUsuarioFormData): Promise<void> => {
    try {
        await baseApiService.put(`/user/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (
    query?: string,
    pagina = 0,
    limite = 10
): Promise<{ items: any[]; totalItems: number }> => {
    try {
        const page = pagina + 1;

        const url = query
            ? `/user?page=${page}&limit=${limite}&${query}`
            : `/user?page=${page}&limit=${limite}`;

        const response = await baseApiService.get(url);
        return response.data.data;

    } catch (error) {
        throw errosHandler(error);
    }
};

const recuperarSenha = async (id: string, data: RecuperarSenhaFormData): Promise<void> => {
    try {
        await baseApiService.put(`/user/password/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};


export const usuarioService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    recuperarSenha
};

